<template>
  <div>
    <div class="tabel-title">
      <el-descriptions title="" :column="1">
        <el-descriptions-item :label="cmp.name">
          <el-breadcrumb separator="|">
            <el-breadcrumb-item v-for="f in cmp.export_fields.t0" :key="f">{{
              f
            }}</el-breadcrumb-item>
          </el-breadcrumb>
        </el-descriptions-item>
        <el-descriptions-item label="包含配件">
          <el-breadcrumb separator="|">
            <el-breadcrumb-item
              v-for="temp in cmp.item_templates"
              :key="temp.id"
              >{{ temp.name }}（{{
                cmp.export_fields['t' + temp.id].join()
              }}）</el-breadcrumb-item
            >
          </el-breadcrumb>
        </el-descriptions-item>
      </el-descriptions>
      <div style="display: flex">
        <div>
          <el-button
            size="small"
            type="primary"
            class="mr-10"
            plain
            @click="handleEdit"
            >编辑组件</el-button
          >
        </div>
        <file-button
          v-permission="
            category == 1 ? Auth.productCmpRecordIE : Auth.instrumenCmpRecordIE
          "
          :obj="category == 2 ? 'product_cmp_record' : 'instrument_cmp_record'"
          :template-id="cmp.id"
          :filter="queryData"
          :importButton="false"
          name="导入拆检记录"
          exportBtnName="导出拆检记录"
          templateLabel="下载导入模板"
          @importCallback="getData"
        ></file-button>
      </div>
    </div>

    <div class="filter mb-10">
      <el-form
        :inline="true"
        :model="filter"
        ref="filterForm"
        label-position="right"
        label-width="80px"
        class="search-form oneline"
        size="small"
        @submit.native.prevent
      >
        <el-form-item label="组件属性">
          <el-input
            size="small"
            v-model="filter.query"
            placeholder="搜索自定义属性值"
          ></el-input>
        </el-form-item>
        <el-form-item label="拆卸基地">
          <BaseSelect v-model="filter.base_id" :filterBlank="true"></BaseSelect>
        </el-form-item>
        <el-form-item label="拆检日期" prop="date">
          <el-date-picker
            v-model="filter.date"
            type="daterange"
            size="small"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData()
            "
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="list" size="small" border v-loading="loading">
      <el-table-column
        :label="cmp.name + '编号'"
        prop="product.code"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        :label="item"
        v-for="item in cmp.export_fields.t0"
        :key="item"
        align="center"
        :min-width="labelWidth(item)"
      >
        <template slot-scope="scope">
          {{ getCustomParamValue(scope.row.product.custom_params, item) }}
        </template>
      </el-table-column>
      <el-table-column
        label="拆检日期"
        prop="disassemb_date"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column label="是否使用" align="center" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.is_used == 1">是</span>
          <span v-else-if="scope.row.is_used == 2">否</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="使用日期"
        prop="ur_date"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        label="工作时长"
        prop="ur_hour"
        align="center"
        width="80"
      >
      </el-table-column>
      <el-table-column align="center" label="使用区块">
        <template slot-scope="scope" v-if="scope.row.ur_id">
          {{ scope.row.ur_extra[0].value }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="井队号">
        <template slot-scope="scope" v-if="scope.row.ur_id">
          {{ scope.row.ur_extra[1].value }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="井号">
        <template slot-scope="scope" v-if="scope.row.ur_id">
          {{ scope.row.ur_extra[2].value }}
        </template>
      </el-table-column>
      <template v-for="temp in cmp.item_templates">
        <el-table-column
          align="center"
          :label="temp.name"
          :key="'a' + temp.id"
          :min-width="labelWidth(temp.name)"
        >
          <template slot-scope="scope">
            {{ scope.row[`t${temp.id}`].item.code }}
          </template>
        </el-table-column>
        <el-table-column
          :label="item"
          v-for="item in cmp.export_fields[`t${temp.id}`]"
          :key="item"
          align="center"
          :min-width="labelWidth(item)"
        >
          <template slot-scope="scope">
            {{
              getCustomParamValue(
                scope.row[`t${temp.id}`].item.custom_params,
                item
              )
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="拆检情况" :key="'b' + temp.id">
          <template slot-scope="scope">
            {{ scope.row[`t${temp.id}`].inspection }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="图片" :key="'c' + temp.id">
          <template slot-scope="scope">
            <el-image
              v-for="url in scope.row[`t${temp.id}`].imgs"
              :key="url"
              style="width: 30px; height: 30px; margin-right: 5px"
              :src="url"
              :preview-src-list="scope.row[`t${temp.id}`].imgs"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" label="视频" :key="'d' + temp.id">
          <template slot-scope="scope">
            <VideoPlayer :srcs="scope.row[`t${temp.id}`].videos"></VideoPlayer>
          </template>
        </el-table-column>
      </template>
    </el-table>

    <el-pagination
      class="mt-20"
      :page-size="filter.size"
      :current-page.sync="filter.page"
      @current-change="getData"
      layout="total, prev, pager, next"
      :total="total"
    ></el-pagination>

    <ComponentFormer
      :model="model"
      :show.sync="componentFormerVisible"
      @edit="componentEditCallback"
    ></ComponentFormer>
  </div>
</template>

<script>
import { productTemplateComponentRecordList } from '@/service/getData'
import ComponentFormer from './componentFormer'

export default {
  components: {
    ComponentFormer,
  },
  props: {
    cmp: {
      type: Object,
      default: () => {},
    },
    category: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
      filter: {
        page: 1,
        size: 10,
        base_id: '',
        query: '',
        date: '',
      },
      total: 0,
      loading: false,
      model: {},
      componentFormerVisible: false,
    }
  },
  computed: {
    labelWidth() {
      return function (label) {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        context.font = '14px Microsoft YaHei'
        const dimension = context.measureText(label)

        let width = dimension.width + 20
        if (width < 90) {
          width = 90
        }
        return width
      }
    },
    queryData() {
      let data = this.clone(this.filter)
      if (data.date && data.date.length == 2) {
        data.disassemb_start_date = data.date[0]
        data.disassemb_end_date = data.date[1]
      }
      data.product_component_template_id = this.cmp.id
      data.category = 6
      data.page -= 1
      return data
    },
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      let res = await productTemplateComponentRecordList(this.queryData)

      this.loading = false
      if (res.code == 0) {
        this.list = res.data.list.map((item) => {
          this.cmp.item_template_ids.map((tid) => {
            item['t' + tid] = { item: {} }
          })
          item.item_records.map((record) => {
            item['t' + record.item.item_template_id] = record
          })
          return item
        })
        this.total = res.data.count
      }
    },

    reset() {
      this.filter.query = ''
      this.filter.base_id = ''
      this.filter.date = ''
      this.filter.page = 1
      this.getData()
    },

    handleEdit() {
      this.model = this.clone(this.cmp)
      if (!this.model.export_fields) {
        this.model.export_fields = {}
      }
      this.componentFormerVisible = true
    },

    componentEditCallback(res) {
      this.cmp.name = res.name
      this.cmp.item_templates = res.item_templates
      this.cmp.item_template_ids = res.item_template_ids
      this.cmp.export_fields = res.export_fields
      this.filter.page = 1
      this.getData()
    },
  },
}
</script>

<style scoped>
.tabel-title {
  display: flex;
  justify-content: space-around;
  margin-bottom: 10px;
}
</style>